<template>
  <div class="bg-gray">
    <div class="form-content">
      <el-form
          :model="formData"
          ref="ruleForm"
          label-width="120px"
          class="demo-ruleForm"
      >
        <div class="form-wrap" v-if="loaded">
          <div v-if="user.status==0||user.status==3">
            <div class="h2">实名认证</div>
            <div class="idimgs">
              <div class="sfz-pic1">
                <img style="width: 100% ; height: 100%" v-if="cardPics[0]" :src="cardPics[0]">
                <input ref="picInput0" @change="uploadPic0" type="file" accept="image/*" multiple=""/>
              </div>
              <div class="sfz-pic2">
                <img style="width: 100% ;height: 100%" v-if="cardPics[1]" :src="cardPics[1]">
                <input ref="picInput1" @change="uploadPic1" type="file" accept="image/*" multiple=""/>
              </div>
            </div>

            <el-row style="padding-top: 20px;">
              <el-col :span="12">
                <el-form-item label="真实姓名" prop="name"
                              :rules="[
    ]"
                >
                  <el-input
                      type="text"
                      placeholder="真实姓名"
                      v-model="formData.name"

                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="身份证号" prop="cardNum"
                >
                  <el-input
                      type="text"
                      placeholder="请输入身份证号"
                      v-model="formData.cardNum"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="12">
                <el-form-item label="有效期限" prop="time_range_str"
                              :rules="[
    ]"
                >
                  <el-input
                      type="text"
                      readonly
                      placeholder="有效期限"
                      v-model="formData.time_range_str"

                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="签发机关" prop="office"
                >
                  <el-input
                      type="text"
                      readonly
                      placeholder="请输入签发机关"
                      v-model="formData.office"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <!--        <van-field-->
            <!--            v-model="formData.name"-->
            <!--            placeholder="真实姓名"-->

            <!--        />-->
            <!--        <van-field-->
            <!--            v-model="formData.cardNum"-->
            <!--            placeholder="身份证号"-->
            <!--        />-->
            <!--        <van-field-->
            <!--            v-model="formData.time_range_str"-->
            <!--            placeholder="有效期限"-->
            <!--            readonly-->
            <!--        />-->
            <!--        <van-field-->
            <!--            v-model="formData.office"-->
            <!--            placeholder="签发机关"-->
            <!--            readonly-->
            <!--        />-->

          </div>
          <div class="tip" v-if="user.status==0||user.status==3">
            <div>
              <van-checkbox v-model="checkXieyi" style="float: left;
                transform: scale(0.6, 0.6);
    -webkit-transform:scale(0.6, 0.6);
    -moz-transform:scale(0.6, 0.6);
    -o-transform:scale(0.6, 0.6);"></van-checkbox>
              同意<el-link class="link" v-rblink="{name:'ContentDetail',query:{id:10}}">《实名认证协议》</el-link>和<el-link class="link"
                                                                                                         v-rblink="{name:'ContentDetail',query:{id:9}}">《用户隐私协议》</el-link>
            </div>
            <div style="padding-left: 19px;">
              并授权平台使用相同姓名及身份证号下的相关用户信息
            </div>

          </div>

          <el-row style="padding: 20px;" v-if="user.status==0||user.status==3">
            <el-col class="footer-button">
              <el-button type="primary" @click="save" :loading="saveLoading">提交认证
              </el-button>
              <!--            <el-button @click="resetForm('ruleForm')" plain>重置</el-button>-->
            </el-col>
          </el-row>
          <!--      <div style="padding: 20px;"  v-if="user.status==0||user.status==3">-->
          <!--        <van-button-->
          <!--            color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"-->
          <!--            round size="large"  @click.stop="save">提交认证</van-button>-->
          <!--      </div>-->
          <div v-if="user.status==0||user.status==3" class="tip" style="text-align: center ; margin: 10px 0">
            平台严格保护用户隐私
          </div>
        </div>

      <div v-if="loaded && user.status==1">
        <div class="cert-status" style="margin-bottom: 20px;">
          <div class="cert-status-content">
            <div class="cert-status-icon-success"></div>
            <p class="cert-status-title tc">认证成功</p>
          </div>
        </div>
        <van-cell-group v-if="user.status==1||user.status==2">
          <el-row>
            <el-col :span="12">
              <el-form-item label="姓名：" prop="name"
                            :rules="[
    ]"
              >
                {{user.user_name}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="身份证号：" prop="cardNum"
              >
                {{user.user_code}}
              </el-form-item>
            </el-col>
          </el-row>
<!--          <van-cell title="姓名" :value="user.user_name"/>-->
<!--          <van-cell title="身份证号" :value="user.user_code"/>-->
        </van-cell-group>
        <van-notice-bar style="font-weight: bold" v-if="user.status==3&&user.admin_note">
          管理员意见:{{ user.admin_note }}
        </van-notice-bar>
      </div>
      <div class="mask" v-if="loadding">
        <van-loading type="spinner" color="white"/>
      </div>
      </el-form>

    </div>
  </div>
</template>

<style scoped="">
.weui-cells:before {
  border: none
}

.form-wrap {
  padding: 0 40px
}

.h2 {
  font-size: 16px;
  font-weight: bold;
  padding: 15px;
  margin: 10px auto 30px auto;
  text-align: center;
}

.idimgs {
}

.idimgs div {
  width: 180px;
  height: 102px;
  background: #eee;
  position: relative;
  margin: 10px auto
}

.idimgs div input {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0
}

.idimgs div.sfz-pic1 {
  background: url(../../../assets/images/cert/bg-idocr0.png) no-repeat;
  background-size: 100%;
}

.idimgs div.sfz-pic2 {
  background: url(../../../assets/images/cert/bg-idocr1.png) no-repeat;
  background-size: 100%;
}

.tip {
  font-size: 14px;
  color: #999;
  margin-top: 20px
}
</style>
<script>
import 'weui/dist/style/weui.min.css'
import {
  Cell, CellGroup, NoticeBar, Field, Button, Loading, Checkbox, Toast
} from 'vant';
// import weui from '../../../static/js/weui.min'
// import $ from 'jquery'

export default {
  name: 'certPersonApply',
  components: {
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [NoticeBar.name]: NoticeBar,
    [Button.name]: Button,
    [Loading.name]: Loading,
    [Checkbox.name]: Checkbox,
  },
  data: function () {
    return {
      loaded: false,
      checkXieyi: true,
      loadding: false,
      formData: {
        name: '',
        cardNum: '',
        time_range_str: '',
        address: '',
        birth: '',
        sex: '',
        nation: '',
        pics: [],
      },
      cardPics: ['', ''
      ],
      user: {
        id: 0,
        user_id: 0,
        status: 0
      },
      fileList: [],
      fileMaxCount: 2,
    }
  },
  mounted: function () {
    document.title = "个人账号认证";
    let vueSelf = this;
    let that = this;
    that.$api.get('/api/user/certData', null, res => {
      that.user = res.data;
      that.loaded = true;
    });
    console.log('create');
  },
  methods: {
    uploadPic0(event) {
      return this.uploadPic(event, 0);
    },
    uploadPic1(event) {
      return this.uploadPic(event, 1);
    },
    uploadPic(event, index) {
      let that = this;
      if (that.loadding) {
        return false;
      }
      that.loadding = true;
      let inputDOM = this.$refs['picInput' + index];
      // 通过DOM取文件数据
      let file = inputDOM.files[0];
      if (inputDOM.files.length > 1) {
        this.$message.warning('每次请选择1张图片');
        that.loadding = false;
        return false;
      }
      let size = Math.floor(file.size / 1024);
      if (size > 10 * 1024 * 1024) {
        this.$message.warning('请选择10M以内的图片');
        that.loadding = false;
        return false
      }

      console.log(file);

      let ossAccessTokenURL = 'https://bc-api.ccachina.net/core/attachment/aliOssSts';
      let ossFileURL = 'https://bc2026.oss-ap-southeast-1.aliyuncs.com';
      OSS.urllib.request(ossAccessTokenURL, {method: 'GET'}, function (err, response) {
        let result;
        if (err) {
          that.$toast.$toast('上传异常:' + err);
          that.loadding = false;
          console && console.error(err);
          return;
        }
        try {
          result = JSON.parse(response);
        } catch (e) {
          that.loadding = false;
          return alert('parse sts response info error: ' + e.message);
        }
        var client = new OSS.Wrapper({
          accessKeyId: result.data.AccessKeyId,
          accessKeySecret: result.data.AccessKeySecret,
          stsToken: result.data.SecurityToken,
          endpoint: result.data.endpoint,
          bucket: result.data.bucket,
          secure: true
        });
        var suffix = file.name.toLowerCase().split('.').splice(-1)[0];
        var myDate = new Date();
        var file_save_name = 'uploader/' + that.getNowFormatDate() + '/user-' + that.user.user_id + '/' + file.lastModified + '.' + suffix;
        console.log(file_save_name);
        let thisfile = this;
        client.multipartUpload(file_save_name, file).then(function (result) {
          var file2 = {
            id: file.id,
            url: ossFileURL + '/' + file_save_name + '?x-oss-process=style/tb-750',
            save_name: file_save_name
          }
          console.log('success');
          console.log(file2);
          that.$set(that.cardPics, index, file2.url);
          that.orcSubmit(file2.url, index);
        }).catch(function (err) {
          console.log('上传失败');
          console.log(err);
          that.loadding = false;
          that.$toast(file.name + '上传失败');
        });
      });
    },
    orcSubmit(url, index) {
      let that = this;
      this.$api.post('/api/user/idOcr', {
        url: url,
        type: index
      }, r => {
        if (index == 0) {
          that.formData.address = r.data.address;
          that.formData.birth = r.data.birth;
          that.formData.cardNum = r.data.cardNum;
          that.formData.name = r.data.name;
          that.formData.nation = r.data.nation;
          that.formData.sex = r.data.sex;
        } else {
          that.formData.office = r.data.issuingAuthority;
          if (r.data.issuingDate) {
            that.formData.time_range_str = r.data.issuingDate + '-' + r.data.expiryDate;
          }
        }
        that.loadding = false;
      }, r => {
        that.$toast(r.msg);
        that.loadding = false;
      })
    },
    getNowFormatDate: function () {
      var date = new Date();
      var seperator1 = "";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      return year + seperator1 + month + seperator1 + strDate;
    },
    save() {
      let that = this;
      this.formData.pics = that.cardPics;
      if (!this.formData.cardNum) {
        this.$message.warning('身份证号码没有被识别,请上传身份证照片');
        return;
      }
      if (!this.formData.time_range_str) {
        this.$message.warning('身份证有效期没有被识别,请上传身份证照片');
        return;
      }
      this.$api.post('/api/user/perCertSubmit', this.formData, r => {
        this.$message.success('认证成功')
        setTimeout(function () {
          rbLink({
            name: 'MyExperience',
            query: {}
          });
        }, 200);
      }, r => {
        this.$message.warning(r.msg);
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// CertPersonApply.vue?045f620a